import { render } from "./ListeNiveauPage.vue?vue&type=template&id=3563a2da&ts=true"
import script from "./ListeNiveauPage.vue?vue&type=script&lang=ts"
export * from "./ListeNiveauPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__